module.exports = __webpack_public_path__ + "img/85eb198007b857b679a114cb4df9ee26.png";